import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Instagram } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/10 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo/Name */}
          <div>
            <p
              className="text-2xl font-bold tracking-wider"
              style={{ fontFamily: 'Bebas Neue, sans-serif' }}
            >
              TOMÁS ROCO
            </p>
          </div>

          {/* Copyright */}
          <div className="text-gray-400 text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
            © {currentYear} Tomás Roco. {t.footer.rights}.
          </div>

          {/* Social */}
          <div className="flex items-center gap-4">
            <a
              href="https://instagram.com/rockito31._"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-red-600 transition-colors"
              aria-label="Instagram Tomás Roco"
            >
              <Instagram size={20} />
            </a>
            <a
              href="https://instagram.com/edgarmerino19"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-red-600 transition-colors"
              aria-label="Instagram Edgar Merino"
            >
              <Instagram size={20} />
            </a>
            <a
              href="https://instagram.com/ikonsagency"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-red-600 transition-colors"
              aria-label="Instagram Ikons Agency"
            >
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
